"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Image = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 5a2 2 0 100 4 2 2 0 000-4zm7.8 3.73l6 8a1 1 0 01.2.6v.92a.76.76 0 01-.75.75H2.75a.76.76 0 01-.75-.75v-.91a1 1 0 01.21-.61l4.25-5.49a.75.75 0 011.17 0l2.19 2.66a.5.5 0 00.78 0l4-5.17a.76.76 0 011.2 0z", clipRule: "evenodd" })); };
exports.Image = Image;
//# sourceMappingURL=image.js.map